// extracted by mini-css-extract-plugin
export default {"list":"collaborator_list__oECQt"};